var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-cascader',{staticClass:"w-full",attrs:{"options":_vm.issue.groups,"props":_vm.prop,"placeholder":_vm.issue.placeholder,"clearable":"","collapse-tags":"","popper-class":"linkage-popper","filterable":""},on:{"change":_vm.onChange},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }